import { useCurrentUser } from "#/components/context/user/UserContext"
import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

export function useAirwallexKycStatus({ enabled }: { enabled: boolean }) {
  const { employeeId } = useCurrentUser()
  return useQuery(["airwallexKycStatus", employeeId], () => carrotClient.getAirwallexKycStatus(), {
    enabled: enabled && employeeId != null,
    retry: buildCarrotApiRetryPolicy(3)
  })
}
